export default __webpack_public_path__ + "static/media/tj.56bff670.svg";